import moment from 'moment';

import { config } from 'config';
import { socket } from 'api';
import { testEvents, nuNotRecognisedEvent, nuGreyListEvent } from 'mocks';
import Event from 'classes/Event';
import { notify } from 'libs/common';
import { user } from 'services/user';
import { isCp } from 'libs/design';

export class AppSocket {
  props;

  constructor(props) {
    this.props = props;

    // socket
    window.socket = socket.init();
    this.initSocketEvents();

    // start: запросы только после подключения к сокету (срабатывает и при переподключении)
    window.socket.on('connect', this.requestInitialData);
    if (window.socket.connected) {
      this.requestInitialData();
    }
  }

  /**
   * начальные запросы в сокет
   */
  requestInitialData = () => {
    // сервер не сразу готов принимать сообщения после connect: шлём один запрос,
    // остальные — по его ответу (см. обработчик dictionaries.list)
    this.restRequested = false;
    socket.call('dictionaries.list');
  };

  /**
   * остальные начальные запросы — после первого ответа сервера
   */
  requestRestData = () => {
    if (this.restRequested) {
      return;
    }
    this.restRequested = true;
    socket.call('get_zones_status');
    socket.call('get_active_events');
    socket.call('get_all_calls');
    socket.call('client_counters.state', { groups: true });
    // статус «Проверка» есть только в новом дизайне
    if (isCp) {
      this.requestAllStates();
    }
  };

  /**
   * опрос состояния всех устройств (список приходит в users.info -> config.nodes)
   */
  requestAllStates = () => {
    const nodes = window.config?.nodes ?? {};
    const userId = user.getId();
    // console.log("nodes", nodes);
    Object.keys(nodes).forEach((id) => {
      socket.call('get_state', { target: id, user_id: userId });
    });
  };

  update(calls, unrecognized) {
    this.props.calls = calls;
    this.props.unrecognized = unrecognized;
  }

  /**
   * 1. window.dict
   * 2. window.user
   * 3. setEvent, setCallActive, addWidget, removeWidget, openWindow, setCall, dropCall, updateStatus, updateStatusBg, setEventsList, setBoardsData, setUnrecognized, calls, unrecognized
   * 4. window.haveRight
   * 5. isActiveCall getActiveCallsCnt
   * 6.
   */
  initSocketEvents = () => {
    const self = this;

    window.socket.on('disconnect', (msg) => {
      console.log('socket: disconnect', msg);
      this.props.doCloseWindows();
    });

    window.socket.on('client_counters.state', (msg) => {
      self.props.doSetCounters(msg);
    });

    /**
     * get adds dictionaries
     */
    window.socket.on('dictionaries.list', (msg) => {
      this.requestRestData();
      // console.log("🚀 ~ AppSocket ~ msg:", msg)
      // find
      const dict = msg.find((value) => {
        return value.id === 'reasonofpass';
      });

      if (dict) {
        window.dict['reasonofpass'] = dict.details;
        // console.log("🚀 ~ AppSocket ~ window.dict['reasonofpass']:", window.dict['reasonofpass'])
      }
    });

    /**
     * logout on error
     */
    window.socket.on('user_error', (__msg) => {
      user.logoutUser();
    });

    /**
     * error ?
     */
    window.socket.on('error', (msg) => {
      //console.log('🚀 ~ backend error', msg);
      if (msg !== 'Validation error') {
        notify('Ошибка', msg);
      }
    });

    /**
     * set signals
     */
    window.socket.on('signals.set', (msg) => {
      self.props.doSetEvent(new Event(msg, true));
    });

    /**
     * call answer
     * broadcast
     */
    window.socket.on('calls.answer', (msg) => {
      // console.log('🚀 ~ window.socket.on ~ msg:', msg);
      // msg - payment-1
      const rightCalls = window.haveRight('mnemo.calls');
      if (!rightCalls) {
        return;
      }
      self.props.doSetCallActive(msg);
      self.props.doAddWidget('activeCall');
    });

    /**
     * call end
     * broadcast
     */
    window.socket.on('calls.end', (msg) => {
      const rightCalls = window.haveRight('mnemo.calls');
      if (!rightCalls) {
        return;
      }

      const id = msg;
      const current = window.isActiveCall(id);
      const all = window.getActiveCallsCnt();
      self.props.doDropCall(id);
      if (!current) {
        return;
      }

      // test for hide
      let d1 = current ? 1 : 0;
      const needHide = all - d1 === 0;
      if (needHide) {
        self.props.doRemoveWidget('activeCall');
      }
    });

    /**
     * calls failed
     */
    window.socket.on('calls.failed', () => {
      const rightCalls = window.haveRight('mnemo.calls');
      if (!rightCalls) {
        return;
      }

      self.props.doOpenWindow({
        id: 'call_error',
        type: 'call_error',
        data: {},
        header: '',
      });
    });

    /**
     * calls call
     */
    window.socket.on('calls.call', (msg) => {
      const rightCalls = window.haveRight('mnemo.calls');
      if (!rightCalls) {
        return;
      }
      //console.log('🚀 ~ calls.call', msg);
      self.props.doSetCall(msg);
    });

    /**
     * get all cals from backend
     */
    window.socket.on('get_all_calls', (msg) => {
      const rightCalls = window.haveRight('mnemo.calls');
      if (!rightCalls) {
        return;
      }

      const map1 = {};
      if (!msg.calls.length) {
        //window.clearActiveCalls();
      }

      msg.calls.forEach((el) => {
        map1[el.source_inner_id] = el;
      });

      for (let key in self.props.calls) {
        if (!map1[key]) {
          self.props.doDropCall(key);
          //window.removeActiveCall(key);
        }
      }

      msg.calls.forEach((el) => {
        self.props.doSetCall(el);
      });
    });

    /**
     * get rack status from backend
     */
    window.socket.on('get_state', (msg) => {
      // console.log('< get_state', msg.target);
      self.props.doUpdateStatus({ source: msg.target, params: msg });
    });

    /**
     * get rack status from backend
     */
    window.socket.on('get_state_background', (msg) => {
      self.props.doUpdateStatusBg({ source: msg.target, params: msg });
    });

    /**
     * get active events from backend
     */
    window.socket.on('get_active_events', (data) => {
      // console.log('🚀 socket <- get_active_events', this.formatEvents(data.events));
      const test = config.testEvents;
      const messages = test ? (test === 'unrecognized' ? nuNotRecognisedEvent : nuGreyListEvent) : data.events;
      const events = {};
      const unrecognized = [];
      for (let key in messages) {
        const msg = messages[key];
        if (msg) {
          if (!events[msg.source]) {
            events[msg.source] = {};
          }
          events[msg.source][msg.id] = new Event(msg, true);
          if (this.isUnrecognized(msg)) {
            unrecognized.push(msg);
          } else {
            this.checkGreyList(msg);
          }
        }
      }
      //console.log(events)
      self.props.doSetEventsList(events);
      self.setUnrecognized(unrecognized);
    });

    /**
     * get event from backend
     */
    window.socket.on('add_event', (data) => {
      // связь с устройством: меняем режим в сторе
      const method = data?.data?.method;
      if ((method === 'controller.offline' || method === 'controller.online') && data?.source) {
        self.props.doSetEquipmentOnline(data.source, method === 'controller.online');
        if (method === 'controller.online') {
          socket.call('get_state_background', { target: data.source, user_id: user.getId() });
        }
      }

      if (data.status !== 'processed') {
        // console.log('🚀 socket <- add_event', this.formatEvent(data));
        self.props.doSetEvent(new Event(data, true));

        //controller.plate_not_match
        if (this.isUnrecognized(data)) {
          //unrecognized = data;
          const current = this.props.unrecognized;
          if (!current || !current.created_at) {
            self.setUnrecognized([data]);
          }
        }
      } else {
        this.checkGreyList(data);
      }
    });

    /**
     * get zone status from backend
     */
    window.socket.on('get_zones_status', (msg) => {
      self.props.doSetBoardsData(msg.zones);
    });
  };

  formatEvents = (events) => {
    return events.map((el) => {
      return this.formatEvent(el);
    });
  };

  formatEvent = (el) => {
    const data = el.data ? el.data : {};
    return { source: el.source, message: el.message, method: data.method, stay_id: data.stay_id, other: el };
  };

  /**
   * set urecognized
   * @param {*} items
   * @returns
   */
  setUnrecognized = (items) => {
    if (!items.length) {
      this.props.doSetUnrecognized(null);
      return;
    }

    // find old one
    if (items.length > 1) {
      items.sort((a, b) => {
        const d1 = moment(a.created_at);
        const d2 = moment(b.created_at);
        if (d1 === d2) {
          return 0;
        }
        const r = d1 - d2;
        //console.log('🚀 ~ items.sort ~ r', d1, d2, r);
        return r;
      });
    }

    // console.log('🚀 socket <- setUnrecognized', items[0]);
    this.props.doSetUnrecognized(items[0]);

    //console.log('🚀 ~ items.sort ~ items', items);
  };

  /**
   * is unrecognized
   * @param {*} data
   * @returns
   */
  isUnrecognized = (data) => {
    if (!window.haveRight('mnemo.allow_payment_mean') || !window.haveRight('mnemo.confirm_events')) {
      return false;
    }
    const methods = ['controller.vehicle_plate_event', 'controller.vehicle_plate_secondtry', 'vehicle_class_not_match_mean'];
    const test = data?.data?.method ?? '';
    const isNotification = data.type === 'notification';

    let out = false;
    methods.forEach((method) => {
      if (isNotification && test.startsWith(method)) {
        out = true;
      }
    });
    return out;
  };

  /**
   * check for grey list
   * @param {*} data
   */
  checkGreyList = (data) => {
    // const test = data.message ?? '';
    const test = data.data ? data.data.method : '';
    if (test === 'gray_plate' || test === 'grey_plate') {
      notify('ГРЗ из серого списка', data.message, 'info', 2000, 'bottom-right', true);
    }
  };
}
